import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/esnext.json.parse.js";
import { setImgsize, loadScript, unescapeHTML, bd_decrypt } from '@/utils/utils';
import { mapState, mapGetters, mapMutations } from 'vuex';
import draggable from 'vuedraggable';
let _ = require('lodash');
import { transform } from 'ol/proj';
import drawlinestyle from '@/components/mapv2/drawlinestyle';
import { ElMessage, ElMessageBox, ElNotification } from 'element-plus';
export default {
  name: 'routedatav2',
  components: {
    draggable,
    drawlinestyle
  },
  meta: {
    title: ''
  },
  props: {
    form: {
      type: Object,
      default: {}
    },
    formlabel: {
      type: Object,
      default: {}
    },
    formoption: {
      type: Object,
      default: {}
    },
    formfield: {
      type: Object,
      default: {}
    },
    mapform: {
      type: Object,
      default: {}
    },
    mapformoption: {
      type: Object,
      default: {}
    },
    isadd: {
      type: Boolean,
      default: true
    },
    typelist: {
      type: Array,
      default: []
    },
    pointlist: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      timer: null,
      routeShow: false,
      typeList: [],
      typeprops: {
        multiple: true
      },
      key1: 0,
      routePointList: [],
      searchKey: '',
      rpointList: [],
      searchflag: false,
      routemapContainer: '',
      routePath: [],
      routeonce: true,
      routeindexlockup: true,
      linestyleValue: ['1'],
      flag1: false,
      linestyle: {},
      mapTimer: null,
      routelinetype: 1,
      oncelock: false,
      routejson: {}
    };
  },
  created() {},
  computed: {
    ...mapGetters(['mapv2info']),
    staticpointlist() {
      return this.rpointList.filter(data => !this.searchKey || data.itemformdata.place_name.toLowerCase().includes(this.searchKey.toLowerCase()));
    },
    formorpontList() {
      let a = this.form;
      let b = this.pointlist;
      return {
        a,
        b
      };
    }
  },
  watch: {
    isadd(val) {
      if (val) this.reset();
    },
    form(val) {},
    pointlist: {
      handler(val) {
        // console.log(`点位数据2`, val)
        this.rpointList = _.cloneDeep(val);
      },
      deep: true
    },
    formorpontList: {
      immediate: true,
      handler(n) {
        if (n.a && n.b && n.a.jsontxt && n.b.length > 0) {
          if (!this.isadd) {
            console.log(`编辑 处理路线详细`);
            // 编辑 处理路线详细
            this.routePointList = [];
            this.routejson = {
              ...JSON.parse(n.a.jsontxt.replace(/(<\/?p.*?>)/gi, ''))
            };
            console.log(`routejson`, this.routejson);
            let pointlist = _.cloneDeep(n.b);
            this.routejson.routedata.forEach(elem => {
              let routepoint = pointlist.find(item => {
                return item.id === elem.id;
              });
              if (routepoint !== undefined) {
                routepoint.itemformdata.speed = elem.speed === undefined ? 4 : elem.speed;
                this.routePointList.push(routepoint);
              }
            });
            console.log(`this.routePointList`, this.routePointList);
            this.linestyle = this.routejson.style;
            // if (this.routePointList.length > 0) this.$emit('routepoint', this.routePointList)
            this.drawroute();
            this.oncelock = false;
          } else {
            this.linestyle = {};
          }
        }
      }
    },
    'mapv2info.style.routelinetype': {
      handler(val) {
        this.routelinetype = val;
        if (this.pointlist.length > 0 && this.routePointList.length > 0) {
          // 仅显示该路线的点位
          // if (this.routePointList.length > 0) this.$emit('routepoint', this.routePointList)
          this.drawroute();
        }
      },
      deep: true
    }
  },
  mounted() {
    this.loadBmap();
    this.oncelock = true;
  },
  methods: {
    ...mapMutations(['SET_MAPROUTESOURCE']),
    loadBmap() {
      // 配置页中supermap 已加载过bdMap.js 所以无需重复加载 定时获取window.BMapGL && window.BMapGL.Map是否存在
      this.mapTimer = setInterval(() => {
        if (window.BMapGL && window.BMapGL.Map) {
          this.routemapContainer = new window.BMapGL.Map('routemap');
          clearInterval(this.mapTimer);
        }
      }, 100);
    },
    submitHandle() {
      if (this.routePointList.length < 2) {
        ElMessage({
          message: '请选择两个及以上点位组成路线',
          type: 'warning'
        });
        return;
      }
      let routearr = this.routePointList.map(item => {
        return {
          id: item.id,
          coordinate: item.itemformdata.map_coordinates.split(',').map(parseFloat),
          title: item.itemformdata.place_name,
          speed: item.itemformdata.speed
        };
      });
      if (this.mapv2info.routeCurve.switch) {
        ElMessage({
          message: '请先设置完曲线',
          type: 'warning'
        });
        return;
      }
      let route = {
        routedata: routearr,
        style: this.linestyle
      };
      // 存储曲线新增点
      if (Object.keys(this.mapv2info.routeCurve).length > 0 && this.mapv2info.style.routelinetype === 3) route.curvedata = this.mapv2info.routeCurve.data;
      console.log(`route`, route);
      this.form.jsontxt = `<p element-id=\"init\" style="display: none;">${JSON.stringify(route)}</p>`;
      this.$refs['formdata'].validate(valid => {
        if (valid) {
          if (/^\d+$/.test(this.form.type)) {
            this.form.typeId = this.form.type;
            this.form.type = this.typelist.find(item => {
              return item.itemformdata.onlyid == this.form.typeId;
            }).itemformdata.title;
          }
          Object.keys(this.linestyle).forEach(elem => {
            if (elem === 'lineDash') {
              this.form[`${elem}`] = this.linestyle[elem];
            } else {
              this.form[`line${elem}`] = this.linestyle[elem];
            }
          });
          console.log(this.form);
          this.$emit('submit', this.form);
        }
      });
    },
    routeopen() {
      this.routeShow = true;
    },
    routeclose() {
      this.reset();
      this.oncelock = false;
      this.routeShow = false;
      this.$emit('clearroute');
    },
    reset() {
      this.routePointList = [];
      this.$refs['formdata'].resetFields();
    },
    pointclick(item) {
      let newitem = _.cloneDeep(item);
      this.routePointList.push(newitem);
      this.searchflag = false;
      console.log(`this.routePointList`, this.routePointList);
      this.oncelock = false;
      if (this.routePointList.length < 2) return;
      // this.$emit('routepoint', this.routePointList)
      this.drawroute();
    },
    deleteroute(index) {
      this.routePointList.splice(index, 1);
      this.drawroute();
    },
    onEnd(val) {
      this.drawroute();
    },
    drawroute() {
      // 初次打开路线数据 防止lineHandle事件二次触发
      if (this.oncelock) return;
      let routes = [];
      this.speeds = [];
      for (let i = 0; i < this.routePointList.length - 1; i++) {
        let start = this.routePointList[i].itemformdata.map_coordinates.split(',').map(parseFloat);
        let end = this.routePointList[i + 1].itemformdata.map_coordinates.split(',').map(parseFloat);
        routes.push([start, end]);
        this.speeds.push(this.routePointList[i].itemformdata.speed);
      }
      // 若存在curvedata参数 代表曲线
      if (this.routejson.curvedata !== undefined && this.routelinetype === 3 && this.routejson.curvedata.length > 0) {
        routes.forEach((item, index) => {
          let curveitem = this.routejson.curvedata[index];
          if (curveitem !== null && curveitem !== undefined) curveitem.forEach((point, pIndex) => {
            item.splice(pIndex + 1, 0, [point[0], point[1]]);
          });
        });
      }
      if (routes.length === 0) {
        this.routePath = [];
        this.SET_MAPROUTESOURCE([]);
        return;
      }
      if (this.routelinetype === 1) {
        this.routePath = [];
        this.routeDriving(routes, 0);
      }
      if (this.routelinetype !== 1) {
        let paths = routes.map(elem => {
          return elem.map(item => {
            return transform([item[0], item[1]], 'EPSG:4326', 'EPSG:3857');
          });
        });
        this.SET_MAPROUTESOURCE([{
          speed: this.speeds,
          path: paths,
          style: this.linestyle,
          routelinetype: this.routelinetype,
          isCurve: this.routeShow && this.routelinetype === 3
        }]);
      }
    },
    routeDriving(routes, index) {
      let route = routes[index];
      if (route === undefined) return;
      let start = new window.BMapGL.Point(route[0][0], route[0][1]);
      let end = new window.BMapGL.Point(route[1][0], route[1][1]);
      let driving = new window.BMapGL.DrivingRoute(this.routemapContainer);
      driving.search(start, end);
      driving.setSearchCompleteCallback(() => {
        let routepath = [];
        if (driving.getResults() === undefined) return;
        let pots = driving.getResults().getPlan(0).getRoute(0).getPath();
        pots.forEach((pot, idx) => {
          let bdTogd = bd_decrypt(pot.lng, pot.lat);
          routepath.push(transform([bdTogd.lng, bdTogd.lat], 'EPSG:4326', 'EPSG:3857'));
        });
        this.routePath.push(routepath);
        if (routes.length === 1 || index === routes.length - 1) {
          console.log(`this.routePath, this.routePath`);
          this.SET_MAPROUTESOURCE([{
            speed: this.speeds,
            path: this.routePath,
            style: this.linestyle,
            routelinetype: this.routelinetype,
            isCurve: this.routeShow && this.routelinetype === 3
          }]);
        }
        if (routes.length > 1 && index < routes.length) this.routeDriving(routes, index + 1);
      });
    },
    lienstylehandleChange(val) {
      this.flag1 = val !== '' ? false : true;
    },
    linestyleHandle(val) {
      this.linestyle = {
        ...val
      };
      this.drawroute();
    },
    /**
     * 点与点之间的速度
    * @param {Object} val form数据
     */
    routeSpeedChange(val, item) {
      console.log(`routeSpeedChange`);
      console.log(val);
      console.log(item);
      // this.oncelock = false
      this.drawroute();
    }
  }
};